setTimeout(function(){

  $(document).ready(function () {
    $('.two-side-wrapper .productSlickSlider').slick({
      slidesToShow: 4.5,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><svg fill="currentColor" viewBox="0 0 20 20"> <path d="M12.707 15.707a1 1 0 01-1.414 0L6 10.414a1 1 0 010-1.414l5.293-5.293a1 1 0 111.414 1.414L8.414 10l4.293 4.293a1 1 0 010 1.414z"></path> </svg></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg fill="currentColor" viewBox="0 0 20 20"> <path d="M7.293 4.293a1 1 0 011.414 0L14 9.586a1 1 0 010 1.414l-5.293 5.293a1 1 0 11-1.414-1.414L11.586 10 7.293 5.707a1 1 0 010-1.414z"></path> </svg></button>',
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: 4.5 },
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 3.5 },
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 2.5 },
        },
      ],
    });
  });


},1000
    )


/* service button */

  document.querySelectorAll('.arrow-toggle').forEach(arrow => {
    arrow.addEventListener('click', function (e) {
      e.stopPropagation();
      this.closest('.service-wrap').classList.toggle('active');
    });
  });




// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('[data-product-form]').forEach(form => {
//     form.addEventListener('submit', async (e) => {
//       e.preventDefault();

//       const formData = new FormData(form);

//       await fetch('/cart/add.js', {
//         method: 'POST',
//         body: formData,
//         headers: {
//           'Accept': 'application/json'
//         }
//       });

//       // CART DRAWER OPEN
//       const cartDrawer = document.querySelector('cart-drawer');
//       if (cartDrawer) {
//         cartDrawer.open();
//       }
//     });
//   });
// });



function openChat() {
  // Yaha apna chat trigger lagao (Tidio / WhatsApp chat / Zendesk)
  alert("Chat support opening...");
}

document.addEventListener("DOMContentLoaded", function() {

    // Only target the Size select, not Metal Purity or Diamond Quality
    const sizeSelect = document.querySelector('.single-option-selector[name="options[Size]"]');

    if (!sizeSelect) return;

    const options = sizeSelect.querySelectorAll('option');

    options.forEach(function(option) {

        const qty = parseInt(option.getAttribute("data-inventory-quantity")) || 0;
        const policy = option.getAttribute("data-inventory-policy");

        let stockText = "";

        if ((qty === 0 || qty === -1) && policy === "continue") {
            stockText = " - Made to Order";
        } 
        else if (qty >= 1) {
            stockText = " - In Stock";
        } 
        else {
            stockText = " - Out of Stock";
        }

        option.textContent = option.value + stockText;

    });

});